import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { editMutations } from './types';
import { CRUMB_LABEL_KEY, NAME as name } from '../constants';
import { apiProvider } from '../api';

const edit = {
	ZaznamId: null as number | null,
	VozidloId: null as number | null,
	VozidloIdText: null as string | null,
	Text: null as string | null,
	UzavreniDat: null as Date | null,
	VyrazenPrp: null as boolean | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	VstupPracIdText: null as number | null,
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	EditPracIdText: null as string | null,
	CheckinUnitId: null as number | null,
	TextPfx: null as string | null,
	TextSfx: null as string | null,
	VozzavtypPzn: null as number | null,
	VozzavstatusPzn: null as number | null,
	PpNr: null as string | null,
	NvskladId: null as number | null,
	VozzavtypPznText: null as string | null,
	VozzavstatusPznText: null as string | null,
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		Vozzavtyp: [],
		Vozzavstatus: [],
		VozzavadatextPfx: [],
		Vozzavadatext: [],
		VozzavadatextSfx: [],
	},
	edit,
	depTableNames: [],
	depTableSettings: {},
	localState: {},
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[editMutations.PRACOVNI_POZICE_PPNR_SELECT_MAPPER](state, { data }) {
			state.edit.PpNr = data.ppNr ? data.ppNr.trim() : null;
			state.edit.Text = data.popis ? data.popis : null;
		},
	},
	props: {
		mode: null,
	},
});
